import { adminSearchShardCatalogGetSlice } from './get';
import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import {
	adminSearchShardCatalogDetailsReducers,
	adminSearchShardCatalogDetailsWatchers } from './details';
import {
	adminSearchShardCatalogReindexCustomerReducers,
	adminSearchShardCatalogReindexCustomerWatchers
} from './reindex-customer';

export const adminSearchShardCatalogReducers = combineReducers({
	details: adminSearchShardCatalogDetailsReducers,
	get: adminSearchShardCatalogGetSlice.asyncReducers,
	reindexCustomer: adminSearchShardCatalogReindexCustomerReducers
});

export const adminSearchShardCatalogWatchers = combineAllWatchers([
	adminSearchShardCatalogDetailsWatchers,
	adminSearchShardCatalogGetSlice.asyncWatchers,
	adminSearchShardCatalogReindexCustomerWatchers
]);
